import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setUser as setUserRedux,} from "../redux/features/auth/AuthSlice"
import { API_USERS } from "../redux/features/auth/AuthServies";
 



const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    axios
      .get(`${API_USERS}getUser`, { withCredentials: true })
      .then((res) => {
        setUser(res.data);
        dispatch(setUserRedux(res.data.data));
      })
      .catch(() => {
        setUser(null);
        dispatch(setUserRedux(null));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export default AuthProvider;
